import script from "./WorkflowRapid.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowRapid.vue?vue&type=script&setup=true&lang=ts"

import "./WorkflowRapid.vue?vue&type=style&index=0&id=624aa558&lang=scss"

const __exports__ = script;

export default __exports__